import { Link } from "react-router-dom";
import { useMyOrders, STATUS_LABEL, STATUS_PILL, PAYMENT_LABEL } from "@/lib/orders";

const fmt = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
const dfmt = new Intl.DateTimeFormat("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" });

export default function MeineBestellungenPage() {
  const { data: orders = [], isLoading } = useMyOrders();
  if (isLoading) return <div className="card">Lade…</div>;
  if (orders.length === 0) {
    return (
      <div className="card text-center space-y-2">
        <h1 className="text-2xl font-bold text-hof-900">Noch keine Bestellungen</h1>
        <Link to="/shop" className="btn-primary inline-block">Zum Hofladen</Link>
      </div>
    );
  }
  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-brand font-bold text-wappen-700">Meine Bestellungen</h1>
      <div className="space-y-2">
        {orders.map((o) => (
          <Link key={o.id} to={`/shop/bestellungen/${o.id}`} className="card block hover:border-wiese-300 transition">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div>
                <div className="font-medium text-hof-900">{o.order_number ?? "—"}</div>
                <div className="text-sm text-hof-700">
                  Lieferung am {dfmt.format(new Date(o.delivery_date))}
                </div>
                <div className="text-xs text-hof-500 mt-1">{PAYMENT_LABEL[o.payment_method]}</div>
              </div>
              <div className="text-right">
                <span className={STATUS_PILL[o.status]}>{STATUS_LABEL[o.status]}</span>
                <div className="text-xl font-semibold text-wiese-700 mt-1">{fmt.format(o.total_cents / 100)}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
